import { useField, useFormikContext } from 'formik';
import React from 'react';
import { getCardType } from '../PayRent/CardTypeIcon';
import { ErrorLabel, getAsterisk } from '../Form/ErrorLabel';

export const CustomUneditableField = ({ label, ...props }: any) => {
  const [field] = useField(props);
  return (
    <>
      <label className="inputLabel">{label}</label>
      <div className="inputFieldDiv">
        <input className="cardDetailsInput inputField" {...field} />
        <div className="overlaySection"></div>
      </div>
    </>
  );
};

export const CustomTextField = ({ label, ...props }: any) => {
  const [field, meta] = useField(props);
  return (
    <>
      <label className="cardLabel">
        {label}
        {getAsterisk()}
      </label>
      <input
        className={`cardDetailsInput ${
          meta.touched && meta.error ? 'invalidCardDetails' : ''
        }`}
        {...field}
        {...props}
      />
      {meta.touched && meta.error ? <ErrorLabel message={meta.error} /> : <></>}
    </>
  );
};
export const CustomTextFieldWithoutAsterisk = ({ label, ...props }: any) => {
  const [field, meta] = useField(props);
  return (
    <>
      <label className="cardLabel">{label}</label>
      <input
        className={`cardDetailsInput ${
          meta.touched && meta.error ? 'invalidCardDetails' : ''
        }`}
        {...field}
        {...props}
      />
      {meta.touched && meta.error ? <ErrorLabel message={meta.error} /> : <></>}
    </>
  );
};

export const CustomPostalCodeField = ({ label, fieldname, ...props }: any) => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();

  return (
    <>
      <label className="cardLabel">
        {label}
        {getAsterisk()}
      </label>
      <input
        className="cardDetailsInput"
        {...field}
        {...props}
        onChange={e => {
          const inNumber = e.target.value;
          if (/^[a-zA-Z0-9 ]*$/.test(inNumber)) {
            setFieldValue(fieldname, inNumber);
          }
        }}
      />
      {meta.touched && meta.error ? <ErrorLabel message={meta.error} /> : <></>}
    </>
  );
};

export const CustomNameField = ({ label, fieldname, ...props }: any) => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();

  return (
    <>
      <label className="cardLabel">
        {label}
        {getAsterisk()}
      </label>
      <input
        className="cardDetailsInput"
        {...field}
        {...props}
        onChange={e => {
          const inNumber = e.target.value;
          if (/^[a-zA-Z ]{0,60}$/.test(inNumber)) {
            setFieldValue(fieldname, inNumber);
          }
        }}
      />
      {meta.touched && meta.error ? <ErrorLabel message={meta.error} /> : <></>}
    </>
  );
};

export const CustomCvvField = ({
  label,
  fieldname,
  cardNumber,
  ...props
}: any) => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();

  const isAmex = getCardType(cardNumber.replace(/-/g, '')) === 'Amex';
  return (
    <>
      <label className="cardLabel">
        {label}
        {getAsterisk()}
      </label>
      <input
        className="cardDetailsInput"
        onPaste={e => {
          e.preventDefault();
        }}
        placeholder={isAmex ? '1234' : '123'}
        {...field}
        {...props}
        onChange={e => {
          const inNumber = e.target.value;
          if (/^\d*$/.test(inNumber)) {
            setFieldValue(fieldname, inNumber);
          }
        }}
      />
      {meta.touched && meta.error ? <ErrorLabel message={meta.error} /> : <></>}
    </>
  );
};

export const CustomFormattedInputField = ({
  label,
  formattingFunction,
  fieldname,
  expression,
  ...props
}: any) => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();

  return (
    <>
      <label className="cardLabel">
        {label}
        {getAsterisk()}
      </label>
      <input
        className="cardDetailsInput"
        onPaste={e => {
          e.preventDefault();
        }}
        {...field}
        {...props}
        onChange={e => {
          const regex = new RegExp(expression);
          const inNumber = e.target.value;
          if (!regex.test(inNumber)) {
            const formattedDate = formattingFunction(e);
            setFieldValue(fieldname, formattedDate);
          }
        }}
      />
      {meta.touched && meta.error ? <ErrorLabel message={meta.error} /> : <></>}
    </>
  );
};

export const CustomCheckBoxField = ({
  label,
  CheckBoxTestId,
  ...props
}: any) => {
  const { disabled = false } = props;
  const [field, meta] = useField(props);
  const { values, setFieldValue } = useFormikContext<any>();
  if (
    props.name === 'autoPay' &&
    values.saveCardDetails === false &&
    values.autoPay === true
  ) {
    setFieldValue('saveCardDetails', true);
  }

  return (
    <label
      className="cardDetailsCheckboxContainer"
      data-testid={CheckBoxTestId}
    >
      <p className="label">{label}</p>
      <input type="checkbox" {...field} {...props} />
      <span className={`checkMark ${disabled ? 'disabled' : ''}`}></span>
      {meta.touched && meta.error ? <ErrorLabel message={meta.error} /> : <></>}
    </label>
  );
};

export const CustomPaymentInputField = ({ fieldname, ...props }: any) => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();
  return (
    <>
      <div className="amountInputSection">
        <input
          className="amountField"
          {...field}
          {...props}
          onChange={e => {
            const inNumber = e.target.value;
            if (/^\d*\.?\d*$/.test(inNumber)) {
              setFieldValue(fieldname, inNumber);
            }
          }}
        />
        <span className="dollarSign">$</span>
        {meta.touched && meta.error ? (
          <ErrorLabel message={meta.error} />
        ) : (
          <></>
        )}
      </div>
    </>
  );
};
